import React from 'react';
import type { BottomSheetBackdropProps } from '@gorhom/bottom-sheet';

export type { BottomSheetBackdropProps };

export const BottomSheetBackdrop: React.FC<BottomSheetBackdropProps> = () => {
  return <></>;
};
